import React from 'react';
import TextField from './v4/TextField';
import { FormContext, TableContext } from '../context';
import { mapValidation, composeValidation, changeRequirement, maskMap as MaskMap } from '@defi/core-utils';
import InputToggle from './InputToggle';
import InputSelect from './InputSelect';
import LinkButton from './LinkButton';
const required = value => value ? undefined : 'Required';
const DataElement = props => {
  const de = props.children.get('DataElement');
  let updatedMask = undefined;
  let deMask = props.children.get('Mask');
  if (deMask === undefined || !deMask.get('hasMask')) {
    const maskForDataElement = MaskMap.getMaskForDataElement(de, true);
    if (maskForDataElement && maskForDataElement.hasMask) {
      updatedMask = maskForDataElement;
    }
  }
  switch (de.get('DataType')) {
    case 'Boolean':
      return /*#__PURE__*/React.createElement(InputToggle, {
        disabled: props.children.get('IsReadOnly'),
        id: '' + de.get('Id'),
        name: de.get('Name'),
        label: de.get('Name'),
        fieldName: de.get('FieldName'),
        validation: props.children.get('IsRequired') ? composeValidation(required) : [],
        active: true,
        required: props.children.get('IsRequired'),
        format: de.get('Format'),
        collapsible: de.get('IsExpandable'),
        context: props.context
      });
    case 'Dropdown':
      return /*#__PURE__*/React.createElement(InputSelect, {
        disabled: props.children.get('IsReadOnly'),
        boolean: de.get('DropdownId') === 'Boolean' ? true : false,
        id: '' + de.get('Id'),
        name: de.get('Name'),
        required: props.children.get('IsRequired'),
        validation: props.children.get('IsRequired') ? composeValidation(required) : [],
        dataElementId: de.get('Id'),
        fieldName: de.get('FieldName'),
        dataElementName: de.get('Name'),
        format: de.get('Format'),
        collapsible: de.get('IsExpandable'),
        options: de.get('DropDownValues') ? de.get('DropDownValues').map(v => {
          return {
            text: v.get('Text'),
            value: v.get('Value')
          };
        }) : de.get('DropDownValues'),
        context: props.context,
        changeRequirement: () => null
      });
    default:
      {
        if (de.get('DataType') === 'GTLTDropdown' && props.children.getIn(['DataElement', 'Name']) !== 'Year') {
          return null;
        }
        let context = props.context;
        if (de.get('Name') === 'Options') {
          return /*#__PURE__*/React.createElement(LinkButton, {
            id: de.get('Id'),
            name: de.get('FieldName'),
            dataElementId: de.get('Id'),
            dataElementName: de.get('Name'),
            context: props.context,
            onClick: de.get('onClick')
          });
        } else {
          return /*#__PURE__*/React.createElement(FormContext.Consumer, null, _ref => {
            let editStatus = _ref.editStatus,
              coApplicantIsActive = _ref.coApplicantIsActive,
              conditionalRequirements = _ref.conditionalRequirements,
              setConditionalRequirement = _ref.setConditionalRequirement,
              employmentDurationInYears = _ref.employmentDurationInYears,
              residencyDurationInYears = _ref.residencyDurationInYears,
              toggleSnackbar = _ref.toggleSnackbar;
            return /*#__PURE__*/React.createElement(TableContext.Consumer, null, _ref2 => {
              let toggle = _ref2.toggle,
                open = _ref2.open;
              return /*#__PURE__*/React.createElement(TextField, {
                context: context,
                editStatus: editStatus,
                showMargin: de.get('IsAppDataOrStatic') !== undefined ? 'none' : undefined,
                validation: de.get('IsAppDataOrStatic') !== undefined ? undefined : mapValidation(props.children, coApplicantIsActive, conditionalRequirements),
                toggleSection: toggle,
                changeRequirement: changeRequirement(de, setConditionalRequirement),
                toggleSnackbar: toggleSnackbar,
                fullWidth: true,
                variant: "standard",
                label: de.get('Name'),
                open: open,
                fieldName: de.get('FieldName'),
                mask: updatedMask ? updatedMask : deMask.toJS()
              }, props.children);
            });
          });
        }
      }
  }
};
export default DataElement;